import React, { forwardRef, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import Tooltip from "@mui/material/Tooltip";
import UsersAdd from "./components/Add";
import UsersTable from "./components/Table";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setUsersData } from "../../../../Redux/slices/mngrSlice";
import { get_users } from "http/components/User";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Users({}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const { users } = useSelector((state) => ({
    users: state.mngr.users,
  }));

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onEnter = () => {
    getData();
  }

  useEffect(() => {
    if (users) handleClose();
  }, [users]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_users();
    if (CheckApiStatus(response)) {
      setData(response.data);
    }
    dispatch(setUsersData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <div onClick={setShowDialog} className="btn-manager btn-manager-primary">
        <Tooltip title={"Users"}>
          <Icons.People size={25} />
        </Tooltip>
      </div>
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"lg"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-delete"
        >
          <DialogTitle className="d-flex flex-row align-items-center justify-content-between">
            <p>{`Users`}</p>
            <UsersAdd />
          </DialogTitle>
          <DialogContent className="p-0">
            {show && <UsersTable data={data} />}
          </DialogContent>
          <DialogActions>
            <MButton label={"Close"} color="secondary" onClick={handleClose} />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
